import {
  getAllBlogs,
  getBlogBySlug,
  getBlogsCategory,
  getBlogsSubCategory,
} from "@/api/actions/blog-actions";
import { createInfiniteQuery } from "@/utils/infinite-query.helper";
import { createQueryKeys } from "@lukemorales/query-key-factory";

export const blogQuery = createQueryKeys("blogs", {
  // Get app blog page data
  all: (id: string) => {
    const queryParams = { populate: "deep,6" };
    return {
      queryKey: [id, queryParams],
      queryFn: () => getAllBlogs(queryParams, id),
    };
  },

  // Blog by slug
  get: (slug: string) => {
    const queryParams = {
      filters: { slug: { $eq: slug } },
      populate: "deep,6",
    };
    return {
      queryKey: [queryParams],
      queryFn: () => getBlogBySlug(queryParams),
    };
  },

  // Get category vise blog data
  getBlogsCategory: (category?: string) => {
    let queryParams;

    if (category) {
      queryParams = {
        filters: { category: { $eq: category } },
        pagination: { pageSize: 4, page: 1 },
        sort: "publish_date:DESC",
        populate: "deep",
      };
    } else {
      queryParams = {
        sort: "publishedAt:DESC",
        populate: "deep",
      };
    }

    return {
      queryKey: [queryParams],
      queryFn: async () => {
        const { data } = await getBlogsCategory(queryParams);

        return data;
      },
    };
  },

  // Get particular SubCateory data
  getBlogsSubCategory: (subCategory: string) => {
    const queryParams = { populate: "deep,2" };
    return {
      queryKey: [subCategory, queryParams],
      queryFn: async () => {
        const { data } = await getBlogsSubCategory(queryParams, subCategory);

        return data;
      },
    };
  },
});

export const blogInfiniteQuery = {
  all: createInfiniteQuery(["_blogs", "all"], getBlogsCategory),
};
